import { InputAdornment, ButtonBase, SvgIcon } from "@mui/material";
import BazarButton from "./BazarButton";
import ClearIcon from "@mui/icons-material/Clear";
import { FC } from "react";
import { useIsMobile } from "hooks";
import SearchIcon from "@mui/icons-material/Search";

type Props = {
  onClear?: () => void;
  onEnter?: () => void;
};

export const SearchButton: FC<Props> = ({ onClear, onEnter }) => {
  const isMobile = useIsMobile();

  return (
    <InputAdornment position="end">
      {isMobile ? null : (
        <ButtonBase
          onClick={onClear}
          sx={{
            position: "absolute",
            right: isMobile ? 90 : 50,
            marginRight: 1.5,
          }}
        >
          <SvgIcon fontSize="small" color="action">
            <ClearIcon />
          </SvgIcon>
        </ButtonBase>
      )}
      <BazarButton
        variant="contained"
        color="secondary"
        sx={{
          position: "absolute",
          right: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "auto",
          height: "100%",
        }}
        onClick={onEnter}
      >
        <SearchIcon />
      </BazarButton>
    </InputAdornment>
  );
};
